import { useState } from "react";
import { Nullable } from "global";
import { useForm } from "react-hook-form";
import { useQuery } from "@apollo/client";
import { zodResolver } from "@hookform/resolvers/zod";
import { Quote, QuoteFormValues } from "modules/quote/types";
import { GetQuoteResponse, GetQuoteVariables } from "modules/quote/api/types";
import { createInitialQuoteFormValue, formQuoteSchema } from "modules/quote";
import { quoteWithEquipment } from "../lib";
import { GET_EQUIPMENT_QUOTE_BY_VO_ID } from "../api/equipment";

interface QuoteState {
  initialQuote: Nullable<Quote>;
  equipmentQuote: Nullable<Quote>;
}

interface Options {
  id: string | undefined;
  VOId: string | undefined;
}

export function useEquipmentQuoteForm({ VOId, id }: Options) {
  const [{ initialQuote, equipmentQuote }, setQuote] = useState<QuoteState>({
    initialQuote: null,
    equipmentQuote: null,
  });

  const form = useForm<QuoteFormValues>({
    mode: "onChange",
    resolver: zodResolver(formQuoteSchema),
    defaultValues: equipmentQuote ?? createInitialQuoteFormValue(id),
  });

  useQuery<GetQuoteResponse, GetQuoteVariables>(GET_EQUIPMENT_QUOTE_BY_VO_ID, {
    skip: !VOId,
    variables: { vendorOpportunityId: VOId! },
    onCompleted(data) {
      if (!data?.vendorOpportunity?.quote) return;
      const equipmentQuote = quoteWithEquipment(data.vendorOpportunity.quote, id!);

      setQuote({ initialQuote: data.vendorOpportunity.quote, equipmentQuote });
      form.reset(equipmentQuote);
    },
  });

  return {
    form,
    initialQuote,
  };
}
